import React, { useState } from "react";

import { SearchDialog } from "../search-dialog/search-dialog";
import { SearchInput } from "../search-input/search-input";

interface SearchProps {
    placeholder?: string;
    apiEndpoint?: string;
    searchPagePath?: string;
    className?: string;
}

export const Search: React.FC<SearchProps> = ({
    placeholder = "Search help",
    apiEndpoint = "/api/help/search",
    searchPagePath,
    className = "",
}) => {
    const [searchValue, setSearchValue] = useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleSearchChange = (value: string) => {
        setSearchValue(value);

        // Open dialog on first keystroke
        if (value.length > 0 && !isDialogOpen) {
            setIsDialogOpen(true);
        }

        // Close dialog when search is cleared
        if (value.length === 0 && isDialogOpen) {
            setIsDialogOpen(false);
        }
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
        setSearchValue("");
    };

    return (
        <>
            <SearchInput
                value={searchValue}
                onChange={handleSearchChange}
                placeholder={placeholder}
                className={className}
            />
            <SearchDialog
                isOpen={isDialogOpen}
                onClose={handleDialogClose}
                searchQuery={searchValue}
                onSearchChange={setSearchValue}
                apiEndpoint={apiEndpoint}
                searchPagePath={searchPagePath}
            />
        </>
    );
};
